<template>
  <CuerpoPrueba />
</template>

<script>
export default {
  name: "Prueba",
  components: {
    CuerpoPrueba: () => import("@/components/user/TestAlumno/Principal.vue")
  }
};
</script>
